import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var StateFlowClass;
function StateFlow() {
  if (StateFlowClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'StateFlow', VOID, VOID, VOID, [1]);
    StateFlowClass = $;
  }
  return StateFlowClass;
}
//region block: exports
export {
  StateFlow as StateFlow1vjmqklz54iz7,
};
//endregion

//# sourceMappingURL=StateFlow.mjs.map
